<template lang="html">
  <div id="chart-trending-turns"></div>
</template>

<script>
  import { mapGetters } from 'vuex';
  // import c3 from 'c3';

  export default {
    data() {
      return {};
    },
    props: {
      liveTrendingData: {
        type: Array,
        default: () => [],
      },
    },
    methods: {},
    computed: {
      ...mapGetters(['getCurrentRT']),
    },
    mounted() {
      const chartArgument = (variablesToShow) => ({
        bindto: '#chart-trending-turns',
        data: {
          json: variablesToShow,
          keys: {
            x: 'rtname',
            // value: ['turns', 'points', 'average'],
            value: ['turns', 'points'],
          },
          colors: {
            turns: '#ec2e7c',
            points: '#293349',
            // average: '#73ccd7',
          },
          names: {
            turns: 'Times Spoken',
            points: 'Points Received From Teacher',
            // average: 'Average Class Points',
          },
          labels: false,
          type: 'bar', // set defaut type
          // types: { // set specific type
          //   average: 'step',
          //   turns: 'line', // can also be 'sline' or 'area'
          // },
          order: false,
        },
        legend: {
          position: 'right',
        },
        axis: {
          x: {
            type: 'category',
          },
        },
        // point: {
        //   r: 4, // size of the circle for 'line', 'sline' and 'area' chart types
        // },
        zoom: {
          enabled: true,
        },
        tooltip: {
          contents: function tooltip(
            d,
            defaultTitleFormat,
            defaultValueFormat,
            color
          ) {
            const config = this.config;
            const titleFormat =
              config.tooltip_format_title || defaultTitleFormat;
            const nameFormat =
              config.tooltip_format_name ||
              function getName(name) {
                return name;
              };
            const valueFormat =
              config.tooltip_format_value || defaultValueFormat;
            let text;
            let i;
            let title;
            let value;
            let name;
            let bgcolor;

            for (i = 0; i < d.length; i += 1) {
              if (!text) {
                title = titleFormat ? titleFormat(d[i].x) : d[i].x;
                text = `<table class='${this.CLASS.tooltip}'>
                        <tr><th colspan='2'>${title}</th></tr></tr>`;
              }

              name = nameFormat(d[i].name);
              value = valueFormat(d[i].value, d[i].ratio, d[i].id, d[i].index);
              bgcolor = this.levelColor
                ? this.levelColor(d[i].value)
                : color(d[i].id);

              text += `<tr><td class='name'>
                      <span style='background-color:${bgcolor}'></span>${name}</td>
                      <td class='value'>${value}</td>
                     </tr>`;
            }
            return `${text}</table>`;
          },
        },
      });
      this.$watch('liveTrendingData', (summaryArray) => {
        const argument = chartArgument(summaryArray);
        import(/* webpackChunkName: "c3" */ 'c3').then((c3) => {
          c3.generate(argument);
        });
        return;
      });
    },
  };
</script>

<style lang="css">
  /* import css from node_modules/c3 */
  @import '~c3/c3.min.css';
  /* can change style using #chart(div id) + c3 class + data id */
  #chart .c3-line-turns {
    stroke-width: 1px;
  }
  #chart .c3-line-average {
    stroke-dasharray: 4;
  }
</style>



// WEBPACK FOOTER //
// trendingTurns.vue?4e7aed3d